import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import { UpdatesStore, UpdateData, UpdatesResponse } from 'pages/Updates/types';

import { AxiosRequestConfig } from 'axios';

const initialState: UpdatesStore = {
  loading: false,
  count: 0,
  updates: [],
};

const reset: CaseReducer<UpdatesStore> = () => initialState;

const loading: CaseReducer<UpdatesStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const updates: CaseReducer<UpdatesStore, PayloadAction<UpdateData[]>> = (state, action) => {
  state.updates = action.payload;
};

const count: CaseReducer<UpdatesStore, PayloadAction<number>> = (state, action) => {
  state.count = action.payload;
};

export const updatesSlice = createSlice({
  name: 'updates',
  initialState,
  reducers: {
    reset,
    loading,
    updates,
    count,
  },
});

export const {
  reset: setReset,
  loading: setLoading,
  updates: setUpdates,
  count: setUpdatesCount,
} = updatesSlice.actions;

export const getUpdates =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<UpdatesResponse>('/api/updates/', params as AxiosRequestConfig['params'])
      .then(({ data }) => {
        const { count, results } = data;
        dispatch(setUpdates(results));
        dispatch(setUpdatesCount(count));
      })
      .finally(() => dispatch(setLoading(false)));
  };
